import { IntegrationPartner } from "./enums/integrationPartner";

export class Integration {
    partner: IntegrationPartner;
    homeTeamId?: string | number;
    awayTeamId?: string | number;
    poolId?: string | number;
    matchId: string | number;
    participantId?: string | number;
    scoreId?: string;
    disconnected?: boolean;
    /**
     * The partner has no API, so REFSIX only sees these fixtures when the
     * referee runs an import themselves. Absent on every live-synced partner,
     * so an existing match needs no migration to read as live.
     *
     * What it changes: a manual match can be deleted (the referee's next import
     * decides whether it comes back), and reconnecting one cannot pull the
     * partner's version back on the spot — there is nothing to call.
     */
    manualSync?: boolean;
    constructor(
        partner: IntegrationPartner,
        homeTeamId: string | number,
        awayTeamId: string | number,
        poolId: string | number,
        matchId: string | number,
        participantId: string | number,
        disconnected: boolean = false,
        manualSync?: boolean
    ) {
        this.partner = partner;
        this.homeTeamId = homeTeamId;
        this.awayTeamId = awayTeamId;
        this.poolId = poolId;
        this.matchId = matchId;
        this.participantId = participantId;
        this.disconnected = disconnected;
        this.manualSync = manualSync;
    }

    static fromJSON(json: any): Integration {
        return new Integration(
            json.partner,
            json.homeTeamId,
            json.awayTeamId,
            json.poolId,
            json.matchId,
            json.participantId,
            json.disconnected,
            json.manualSync
        );
    }
}
